/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';
import type { CurrentRateMatch } from './CurrentRateMatch';
import {
    CurrentRateMatchFromJSON,
    CurrentRateMatchFromJSONTyped,
    CurrentRateMatchToJSON,
    CurrentRateMatchToJSONTyped,
} from './CurrentRateMatch';
import type { BookingDetails } from './BookingDetails';
import {
    BookingDetailsFromJSON,
    BookingDetailsFromJSONTyped,
    BookingDetailsToJSON,
    BookingDetailsToJSONTyped,
} from './BookingDetails';
import type { MonitoringStatus } from './MonitoringStatus';
import {
    MonitoringStatusFromJSON,
    MonitoringStatusFromJSONTyped,
    MonitoringStatusToJSON,
    MonitoringStatusToJSONTyped,
} from './MonitoringStatus';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * 
 * @export
 * @interface Hotel
 */
export interface Hotel {
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    emailId?: string;
    /**
     * 
     * @type {number}
     * @memberof Hotel
     */
    vervotechPropertyId?: number;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    supplierId?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    chainName?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    checkInDatetime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    checkOutDatetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    checkinStr?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    checkoutStr?: string;
    /**
     * 
     * @type {number}
     * @memberof Hotel
     */
    nights?: number;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    confirmationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    cancellationNumber?: string;
    /**
     * Gondola-internal booking ID. For user-facing Gondola confirmation number, use gondola_booking_id instead.
     * @type {number}
     * @memberof Hotel
     */
    bookingId?: number;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    guestFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    guestLastName?: string;
    /**
     * User-facing Gondola booking confirmation number.
     * @type {string}
     * @memberof Hotel
     */
    gondolaBookingId?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    roomType?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    rateName?: string;
    /**
     * 
     * @type {number}
     * @memberof Hotel
     */
    roomCount?: number;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    guests?: string;
    /**
     * 
     * @type {number}
     * @memberof Hotel
     */
    adults?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Hotel
     */
    children?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    occupancy?: string;
    /**
     * 
     * @type {number}
     * @memberof Hotel
     */
    totalCost?: number;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    currency?: string;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof Hotel
     */
    averageNightlyRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof Hotel
     */
    totalTaxesFees?: CurrencyAmount;
    /**
     * The currency of the rate the user booked with (e.g. amex vs marriott)
     * @type {string}
     * @memberof Hotel
     */
    pointsRateCurrency?: string;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof Hotel
     */
    currentPrice?: CurrencyAmount;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    currentPriceUpdatedAt?: Date;
    /**
     * 
     * @type {CurrentRateMatch}
     * @memberof Hotel
     */
    currentRateMatch?: CurrentRateMatch;
    /**
     * The points price of the hotel currency (e.g. Marriott points).
     * @type {number}
     * @memberof Hotel
     */
    currentPointsPrice?: number;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    currentPointsPriceUpdatedAt?: Date;
    /**
     * 
     * @type {CurrentRateMatch}
     * @memberof Hotel
     */
    currentPointsRateMatch?: CurrentRateMatch;
    /**
     * The ratio of points to the booking currency (e.g. 10:1)
     * @type {number}
     * @memberof Hotel
     */
    transferRatio?: number;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    cancellableUntil?: Date;
    /**
     * 
     * @type {number}
     * @memberof Hotel
     */
    totalPointsRedeemed?: number;
    /**
     * The equivalent total points redeemed in the hotel currency (e.g. Marriott points)
     * @type {number}
     * @memberof Hotel
     */
    totalPointsRedeemedCurrencyEquivalent?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Hotel
     */
    isPointsBooking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hotel
     */
    cancelled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hotel
     */
    refundable?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    reservationUpdatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    reservationCancellationPolicy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hotel
     */
    reservationUpdateInProgress?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    hotelSupplier?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    bookingAgent?: string;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    bookingDate?: Date;
    /**
     * The loyalty program of the hotel
     * @type {string}
     * @memberof Hotel
     */
    loyaltyProgram?: string;
    /**
     * 
     * @type {BookingDetails}
     * @memberof Hotel
     */
    bookingDetails?: BookingDetails;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    tripId?: string;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    scheduledEventCode?: string;
    /**
     * The loyalty ID of the hotel
     * @type {string}
     * @memberof Hotel
     */
    loyaltyId?: string;
    /**
     * The number of loyalty program status nights accrued
     * @type {number}
     * @memberof Hotel
     */
    statusNights?: number;
    /**
     * 
     * @type {PointsAmount}
     * @memberof Hotel
     */
    loyaltyPointsEarned?: PointsAmount;
    /**
     * The last four digits of the card used to book the hotel
     * @type {string}
     * @memberof Hotel
     */
    cardLastFour?: string;
    /**
     * 
     * @type {PointsAmount}
     * @memberof Hotel
     */
    creditCardEarnings?: PointsAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof Hotel
     */
    gondolaCash?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof Hotel
     */
    totalCashEquivalentEarnings?: CurrencyAmount;
    /**
     * The percentage of the total earnings that are cash equivalents
     * @type {number}
     * @memberof Hotel
     */
    totalEarningsPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof Hotel
     */
    rateUpdateStatus?: HotelRateUpdateStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Hotel
     */
    deletedAt?: Date;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof Hotel
     */
    cashSavingsAmount?: CurrencyAmount;
    /**
     * 
     * @type {PointsAmount}
     * @memberof Hotel
     */
    pointsSavingsAmount?: PointsAmount;
    /**
     * Whether this hotel stay is opted in to auto-save or not.
     * @type {boolean}
     * @memberof Hotel
     */
    autoSave?: boolean;
    /**
     * ID of the payment method to use for auto-save on this stay.
     * @type {string}
     * @memberof Hotel
     */
    paymentMethodId?: string | null;
    /**
     * The URL to the hotel stay on Gondola
     * @type {string}
     * @memberof Hotel
     */
    gondolaUrl?: string;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof Hotel
     */
    potentialGondolaCash?: CurrencyAmount;
    /**
     * The full address of the hotel used for creating a new hotel entity
     * @type {string}
     * @memberof Hotel
     */
    fullAddress?: string;
    /**
     * The Gondola rate ID of the current price of the hotel stay
     * @type {number}
     * @memberof Hotel
     */
    currentPriceGondolaRateId?: number;
    /**
     * The link to current price rate from supplier
     * @type {string}
     * @memberof Hotel
     */
    rateUrl?: string;
    /**
     * Suite upgrade status for this stay
     * @type {string}
     * @memberof Hotel
     */
    upgradeStatus?: HotelUpgradeStatusEnum;
    /**
     * Type of upgrade certificate used
     * @type {string}
     * @memberof Hotel
     */
    upgradeCertificateType?: HotelUpgradeCertificateTypeEnum;
    /**
     * Number of certificates applied (Marriott uses 1 per night)
     * @type {number}
     * @memberof Hotel
     */
    upgradeCertificatesUsed?: number;
    /**
     * Suite type if upgrade confirmed
     * @type {string}
     * @memberof Hotel
     */
    upgradeRoomType?: string;
    /**
     * Room type before upgrade
     * @type {string}
     * @memberof Hotel
     */
    originalRoomType?: string;
    /**
     * When the upgrade was detected
     * @type {Date}
     * @memberof Hotel
     */
    upgradeDetectedAt?: Date;
    /**
     * 
     * @type {MonitoringStatus}
     * @memberof Hotel
     */
    monitoringStatus?: MonitoringStatus;
    /**
     * Human-readable explanation of the monitoring state.
     * @type {string}
     * @memberof Hotel
     */
    monitoringReason?: string | null;
    /**
     * Fields the user can provide to enable monitoring or AutoSave.
     * @type {Array<string>}
     * @memberof Hotel
     */
    missingFields?: Array<string>;
    /**
     * Whether AutoSave can be enabled for this reservation.
     * @type {boolean}
     * @memberof Hotel
     */
    autosaveAvailable?: boolean;
    /**
     * When we last checked the current rate for this reservation.
     * @type {Date}
     * @memberof Hotel
     */
    monitoringLastCheckedAt?: Date | null;
}


/**
 * @export
 */
export const HotelRateUpdateStatusEnum = {
    Pending: 'PENDING',
    BookingSubmitted: 'BOOKING_SUBMITTED',
    BookingCompleted: 'BOOKING_COMPLETED',
    CancelSubmitted: 'CANCEL_SUBMITTED',
    CancelFailed: 'CANCEL_FAILED',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    RateExpired: 'RATE_EXPIRED',
    ReservationIneligible: 'RESERVATION_INELIGIBLE',
    PaymentMethodIneligible: 'PAYMENT_METHOD_INELIGIBLE'
} as const;
export type HotelRateUpdateStatusEnum = typeof HotelRateUpdateStatusEnum[keyof typeof HotelRateUpdateStatusEnum];

/**
 * @export
 */
export const HotelUpgradeStatusEnum = {
    None: 'none',
    AppliedPending: 'applied_pending',
    Confirmed: 'confirmed',
    Denied: 'denied',
    Expired: 'expired'
} as const;
export type HotelUpgradeStatusEnum = typeof HotelUpgradeStatusEnum[keyof typeof HotelUpgradeStatusEnum];

/**
 * @export
 */
export const HotelUpgradeCertificateTypeEnum = {
    Nua: 'nua',
    Sua: 'sua',
    Cur: 'cur',
    IhgSuiteUpgrade: 'ihg_suite_upgrade'
} as const;
export type HotelUpgradeCertificateTypeEnum = typeof HotelUpgradeCertificateTypeEnum[keyof typeof HotelUpgradeCertificateTypeEnum];


/**
 * Check if a given object implements the Hotel interface.
 */
export function instanceOfHotel(value: object): value is Hotel {
    return true;
}

export function HotelFromJSON(json: any): Hotel {
    return HotelFromJSONTyped(json, false);
}

export function HotelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Hotel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'emailId': json['email_id'] == null ? undefined : json['email_id'],
        'vervotechPropertyId': json['vervotech_property_id'] == null ? undefined : json['vervotech_property_id'],
        'supplierId': json['supplier_id'] == null ? undefined : json['supplier_id'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'name': json['name'] == null ? undefined : json['name'],
        'checkInDatetime': json['check_in_datetime'] == null ? undefined : (new Date(json['check_in_datetime'])),
        'checkOutDatetime': json['check_out_datetime'] == null ? undefined : (new Date(json['check_out_datetime'])),
        'checkinStr': json['checkin_str'] == null ? undefined : json['checkin_str'],
        'checkoutStr': json['checkout_str'] == null ? undefined : json['checkout_str'],
        'nights': json['nights'] == null ? undefined : json['nights'],
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'cancellationNumber': json['cancellation_number'] == null ? undefined : json['cancellation_number'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'guestFirstName': json['guest_first_name'] == null ? undefined : json['guest_first_name'],
        'guestLastName': json['guest_last_name'] == null ? undefined : json['guest_last_name'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'roomType': json['room_type'] == null ? undefined : json['room_type'],
        'rateName': json['rate_name'] == null ? undefined : json['rate_name'],
        'roomCount': json['room_count'] == null ? undefined : json['room_count'],
        'guests': json['guests'] == null ? undefined : json['guests'],
        'adults': json['adults'] == null ? undefined : json['adults'],
        'children': json['children'] == null ? undefined : json['children'],
        'occupancy': json['occupancy'] == null ? undefined : json['occupancy'],
        'totalCost': json['total_cost'] == null ? undefined : json['total_cost'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'averageNightlyRate': json['average_nightly_rate'] == null ? undefined : CurrencyAmountFromJSON(json['average_nightly_rate']),
        'totalTaxesFees': json['total_taxes_fees'] == null ? undefined : CurrencyAmountFromJSON(json['total_taxes_fees']),
        'pointsRateCurrency': json['points_rate_currency'] == null ? undefined : json['points_rate_currency'],
        'currentPrice': json['current_price'] == null ? undefined : CurrencyAmountFromJSON(json['current_price']),
        'currentPriceUpdatedAt': json['current_price_updated_at'] == null ? undefined : (new Date(json['current_price_updated_at'])),
        'currentRateMatch': json['current_rate_match'] == null ? undefined : CurrentRateMatchFromJSON(json['current_rate_match']),
        'currentPointsPrice': json['current_points_price'] == null ? undefined : json['current_points_price'],
        'currentPointsPriceUpdatedAt': json['current_points_price_updated_at'] == null ? undefined : (new Date(json['current_points_price_updated_at'])),
        'currentPointsRateMatch': json['current_points_rate_match'] == null ? undefined : CurrentRateMatchFromJSON(json['current_points_rate_match']),
        'transferRatio': json['transfer_ratio'] == null ? undefined : json['transfer_ratio'],
        'cancellableUntil': json['cancellable_until'] == null ? undefined : (new Date(json['cancellable_until'])),
        'totalPointsRedeemed': json['total_points_redeemed'] == null ? undefined : json['total_points_redeemed'],
        'totalPointsRedeemedCurrencyEquivalent': json['total_points_redeemed_currency_equivalent'] == null ? undefined : json['total_points_redeemed_currency_equivalent'],
        'isPointsBooking': json['is_points_booking'] == null ? undefined : json['is_points_booking'],
        'cancelled': json['cancelled'] == null ? undefined : json['cancelled'],
        'refundable': json['refundable'] == null ? undefined : json['refundable'],
        'reservationUpdatedAt': json['reservation_updated_at'] == null ? undefined : (new Date(json['reservation_updated_at'])),
        'reservationCancellationPolicy': json['reservation_cancellation_policy'] == null ? undefined : json['reservation_cancellation_policy'],
        'reservationUpdateInProgress': json['reservation_update_in_progress'] == null ? undefined : json['reservation_update_in_progress'],
        'hotelSupplier': json['hotel_supplier'] == null ? undefined : json['hotel_supplier'],
        'bookingAgent': json['booking_agent'] == null ? undefined : json['booking_agent'],
        'bookingDate': json['booking_date'] == null ? undefined : (new Date(json['booking_date'])),
        'loyaltyProgram': json['loyalty_program'] == null ? undefined : json['loyalty_program'],
        'bookingDetails': json['booking_details'] == null ? undefined : BookingDetailsFromJSON(json['booking_details']),
        'tripId': json['trip_id'] == null ? undefined : json['trip_id'],
        'scheduledEventCode': json['scheduled_event_code'] == null ? undefined : json['scheduled_event_code'],
        'loyaltyId': json['loyalty_id'] == null ? undefined : json['loyalty_id'],
        'statusNights': json['status_nights'] == null ? undefined : json['status_nights'],
        'loyaltyPointsEarned': json['loyalty_points_earned'] == null ? undefined : PointsAmountFromJSON(json['loyalty_points_earned']),
        'cardLastFour': json['card_last_four'] == null ? undefined : json['card_last_four'],
        'creditCardEarnings': json['credit_card_earnings'] == null ? undefined : PointsAmountFromJSON(json['credit_card_earnings']),
        'gondolaCash': json['gondola_cash'] == null ? undefined : CurrencyAmountFromJSON(json['gondola_cash']),
        'totalCashEquivalentEarnings': json['total_cash_equivalent_earnings'] == null ? undefined : CurrencyAmountFromJSON(json['total_cash_equivalent_earnings']),
        'totalEarningsPercentage': json['total_earnings_percentage'] == null ? undefined : json['total_earnings_percentage'],
        'rateUpdateStatus': json['rate_update_status'] == null ? undefined : json['rate_update_status'],
        'deletedAt': json['deleted_at'] == null ? undefined : (new Date(json['deleted_at'])),
        'cashSavingsAmount': json['cash_savings_amount'] == null ? undefined : CurrencyAmountFromJSON(json['cash_savings_amount']),
        'pointsSavingsAmount': json['points_savings_amount'] == null ? undefined : PointsAmountFromJSON(json['points_savings_amount']),
        'autoSave': json['auto_save'] == null ? undefined : json['auto_save'],
        'paymentMethodId': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'gondolaUrl': json['gondola_url'] == null ? undefined : json['gondola_url'],
        'potentialGondolaCash': json['potential_gondola_cash'] == null ? undefined : CurrencyAmountFromJSON(json['potential_gondola_cash']),
        'fullAddress': json['full_address'] == null ? undefined : json['full_address'],
        'currentPriceGondolaRateId': json['current_price_gondola_rate_id'] == null ? undefined : json['current_price_gondola_rate_id'],
        'rateUrl': json['rate_url'] == null ? undefined : json['rate_url'],
        'upgradeStatus': json['upgrade_status'] == null ? undefined : json['upgrade_status'],
        'upgradeCertificateType': json['upgrade_certificate_type'] == null ? undefined : json['upgrade_certificate_type'],
        'upgradeCertificatesUsed': json['upgrade_certificates_used'] == null ? undefined : json['upgrade_certificates_used'],
        'upgradeRoomType': json['upgrade_room_type'] == null ? undefined : json['upgrade_room_type'],
        'originalRoomType': json['original_room_type'] == null ? undefined : json['original_room_type'],
        'upgradeDetectedAt': json['upgrade_detected_at'] == null ? undefined : (new Date(json['upgrade_detected_at'])),
        'monitoringStatus': json['monitoring_status'] == null ? undefined : MonitoringStatusFromJSON(json['monitoring_status']),
        'monitoringReason': json['monitoring_reason'] == null ? undefined : json['monitoring_reason'],
        'missingFields': json['missing_fields'] == null ? undefined : json['missing_fields'],
        'autosaveAvailable': json['autosave_available'] == null ? undefined : json['autosave_available'],
        'monitoringLastCheckedAt': json['monitoring_last_checked_at'] == null ? undefined : (new Date(json['monitoring_last_checked_at'])),
    };
}

export function HotelToJSON(json: any): Hotel {
    return HotelToJSONTyped(json, false);
}

export function HotelToJSONTyped(value?: Hotel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email_id': value['emailId'],
        'vervotech_property_id': value['vervotechPropertyId'],
        'supplier_id': value['supplierId'],
        'chain_name': value['chainName'],
        'name': value['name'],
        'check_in_datetime': value['checkInDatetime'] == null ? value['checkInDatetime'] : value['checkInDatetime'].toISOString(),
        'check_out_datetime': value['checkOutDatetime'] == null ? value['checkOutDatetime'] : value['checkOutDatetime'].toISOString(),
        'checkin_str': value['checkinStr'],
        'checkout_str': value['checkoutStr'],
        'nights': value['nights'],
        'confirmation_number': value['confirmationNumber'],
        'cancellation_number': value['cancellationNumber'],
        'booking_id': value['bookingId'],
        'guest_first_name': value['guestFirstName'],
        'guest_last_name': value['guestLastName'],
        'gondola_booking_id': value['gondolaBookingId'],
        'room_type': value['roomType'],
        'rate_name': value['rateName'],
        'room_count': value['roomCount'],
        'guests': value['guests'],
        'adults': value['adults'],
        'children': value['children'],
        'occupancy': value['occupancy'],
        'total_cost': value['totalCost'],
        'currency': value['currency'],
        'average_nightly_rate': CurrencyAmountToJSON(value['averageNightlyRate']),
        'total_taxes_fees': CurrencyAmountToJSON(value['totalTaxesFees']),
        'points_rate_currency': value['pointsRateCurrency'],
        'current_price': CurrencyAmountToJSON(value['currentPrice']),
        'current_price_updated_at': value['currentPriceUpdatedAt'] == null ? value['currentPriceUpdatedAt'] : value['currentPriceUpdatedAt'].toISOString(),
        'current_rate_match': CurrentRateMatchToJSON(value['currentRateMatch']),
        'current_points_price': value['currentPointsPrice'],
        'current_points_price_updated_at': value['currentPointsPriceUpdatedAt'] == null ? value['currentPointsPriceUpdatedAt'] : value['currentPointsPriceUpdatedAt'].toISOString(),
        'current_points_rate_match': CurrentRateMatchToJSON(value['currentPointsRateMatch']),
        'transfer_ratio': value['transferRatio'],
        'cancellable_until': value['cancellableUntil'] == null ? value['cancellableUntil'] : value['cancellableUntil'].toISOString(),
        'total_points_redeemed': value['totalPointsRedeemed'],
        'total_points_redeemed_currency_equivalent': value['totalPointsRedeemedCurrencyEquivalent'],
        'is_points_booking': value['isPointsBooking'],
        'cancelled': value['cancelled'],
        'refundable': value['refundable'],
        'reservation_updated_at': value['reservationUpdatedAt'] == null ? value['reservationUpdatedAt'] : value['reservationUpdatedAt'].toISOString(),
        'reservation_cancellation_policy': value['reservationCancellationPolicy'],
        'reservation_update_in_progress': value['reservationUpdateInProgress'],
        'hotel_supplier': value['hotelSupplier'],
        'booking_agent': value['bookingAgent'],
        'booking_date': value['bookingDate'] == null ? value['bookingDate'] : value['bookingDate'].toISOString(),
        'loyalty_program': value['loyaltyProgram'],
        'booking_details': BookingDetailsToJSON(value['bookingDetails']),
        'trip_id': value['tripId'],
        'scheduled_event_code': value['scheduledEventCode'],
        'loyalty_id': value['loyaltyId'],
        'status_nights': value['statusNights'],
        'loyalty_points_earned': PointsAmountToJSON(value['loyaltyPointsEarned']),
        'card_last_four': value['cardLastFour'],
        'credit_card_earnings': PointsAmountToJSON(value['creditCardEarnings']),
        'gondola_cash': CurrencyAmountToJSON(value['gondolaCash']),
        'total_cash_equivalent_earnings': CurrencyAmountToJSON(value['totalCashEquivalentEarnings']),
        'total_earnings_percentage': value['totalEarningsPercentage'],
        'rate_update_status': value['rateUpdateStatus'],
        'deleted_at': value['deletedAt'] == null ? value['deletedAt'] : value['deletedAt'].toISOString(),
        'cash_savings_amount': CurrencyAmountToJSON(value['cashSavingsAmount']),
        'points_savings_amount': PointsAmountToJSON(value['pointsSavingsAmount']),
        'auto_save': value['autoSave'],
        'payment_method_id': value['paymentMethodId'],
        'gondola_url': value['gondolaUrl'],
        'potential_gondola_cash': CurrencyAmountToJSON(value['potentialGondolaCash']),
        'full_address': value['fullAddress'],
        'current_price_gondola_rate_id': value['currentPriceGondolaRateId'],
        'rate_url': value['rateUrl'],
        'upgrade_status': value['upgradeStatus'],
        'upgrade_certificate_type': value['upgradeCertificateType'],
        'upgrade_certificates_used': value['upgradeCertificatesUsed'],
        'upgrade_room_type': value['upgradeRoomType'],
        'original_room_type': value['originalRoomType'],
        'upgrade_detected_at': value['upgradeDetectedAt'] == null ? value['upgradeDetectedAt'] : value['upgradeDetectedAt'].toISOString(),
        'monitoring_status': MonitoringStatusToJSON(value['monitoringStatus']),
        'monitoring_reason': value['monitoringReason'],
        'missing_fields': value['missingFields'],
        'autosave_available': value['autosaveAvailable'],
        'monitoring_last_checked_at': value['monitoringLastCheckedAt'] == null ? value['monitoringLastCheckedAt'] : value['monitoringLastCheckedAt'].toISOString(),
    };
}

